import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import {
  BASE_URL,
  GET_COMPANY_GROUP,
  GET_PERMISSION_COMPANY_MODULE,
  SELECT_COMPANY_PERMISSION_LEVEL,
  ADD_UPDATE_PERMISSION_COMPANY,
  COMPANY_HEADER,
  GET_VALUE,
  BULK_ASSIGN,
  GET_ALL_MODULESANDTASK,
} from "../constants";
import { getUserToken } from "../utilityFunctions/localServices";

export const companyManagePermissions = createApi({
  reducerPath: "companyManagePermissions",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    fetchPermissionTableData: builder.query({
      query: ({ token, pagination }) => {
        const params = new URLSearchParams({
          ...pagination,
        });
        // example id
        const storedData = localStorage.getItem("company_data");
        const companyId = JSON.parse(storedData);
        const id = companyId.company_id;
        const url = `${GET_COMPANY_GROUP}${id}?${params.toString()}`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
    bulkAssignSignup: builder.mutation({
      query: ({ payload }) => ({
        url: `${BULK_ASSIGN}`, // Endpoint URL
        method: "POST",
        headers: {
          Authorization: `Bearer ${getUserToken()}`,
          "Content-Type": "application/json",
        },
        body: payload, // Sending data in the request body
      }),
    }),
  }),
});

export const { useFetchPermissionTableDataQuery, useBulkAssignSignupMutation } = companyManagePermissions;

export const PermissionsAddUpdate = createApi({
  reducerPath: "PermissionsAddUpdate",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    PermissionsAddUpdate: builder.mutation({
      query: ({ token, data }) => ({
        url: `${ADD_UPDATE_PERMISSION_COMPANY}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
    }),
  }),
});

export const { usePermissionsAddUpdateMutation } = PermissionsAddUpdate;

export const selectPermission = createApi({
  reducerPath: "selectPermission",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    fetchSelectPermission: builder.query({
      query: ({ token, company_id }) => {
        const url = `${SELECT_COMPANY_PERMISSION_LEVEL}/${company_id}`;
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
  }),
});

export const { useFetchSelectPermissionQuery } = selectPermission;

export const PermissionModuleCompany = createApi({
  reducerPath: "PermissionModuleCompnay",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    fetchPermissionModule: builder.query({
      query: ({ token, id, company_id }) => {
        const url = `${GET_PERMISSION_COMPANY_MODULE}?${company_id ? `company_id=${company_id}` : ""}${id ? `&id=${id}` : ""}`;
        return {
          url: url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    //endpoint for company add Update
    fetchCompanyStructure: builder.query({
      query: ({ page }) => {
        const url = `${COMPANY_HEADER}${page}`;
        return {
          url: url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchCompanyDataId: builder.query({
      query: ({ id, page }) => {
        const url = `${GET_VALUE}${id}&page=${page}`;
        return {
          url: url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),

    fetchAllModualsAndTask: builder.query({
      query: () => {
        const url = `${GET_ALL_MODULESANDTASK}`; // Endpoint URL
        return {
          url,
          method: "GET",
          headers: {
            Authorization: `Bearer ${getUserToken()}`,
            "Content-Type": "application/json",
          },
        };
      },
    }),
  }),
});

export const {
  useFetchPermissionModuleQuery,
  useLazyFetchPermissionModuleQuery,
  useLazyFetchCompanyStructureQuery,
  useLazyFetchCompanyDataIdQuery,
  useFetchAllModualsAndTaskQuery,
} = PermissionModuleCompany;
